import React, { useEffect, useState } from "react";
import {
  useDeleteConfigDataMutation,
  useGetAllConfigDataQuery,
  useUpdateConfigDataMutation,
} from "../../../../../../services/configuration/ConfigDataServices";
import EditDelete from "../../../EditDelete";
import Toster from "../../../Toster";
import EditBlogSubCategory from "../edit/EditBlogSubCategory";
import BlogSubCategoryListing from "./BlogSubCategoryListing";
import AuthWrapper from "../../../../../../utils/AuthWrapper";
import { getFilterdColumns } from "../../../../../../utils/getFilterFunction";

const columns = [
  {
    id: "subcategory_name",
    label: "Subcategory Name",
    minWidth: 50,
    align: "left",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "order_rank",
    label: "Order",
    minWidth: 50,
    align: "left",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "actions",
    label: "Actions",
    minWidth: 50,
    align: "left",
    format: (value) => value.toLocaleString("en-US"),
    authName: ["CONFIGURATION_BLOG_SUB_CATEGORY_DELETE", "CONFIGURATION_BLOG_SUB_CATEGORY_EDIT"],

  },
];

const BlogSubCategoryListingWrapper = () => {
  const [rows, setRows] = useState([]);
  const [configDataId, setConfigDataId] = useState("");
  const [getId, setGetId] = useState("");
  const [editDialog, setEditDialog] = useState(false);
  const [editData, setEditData] = useState("");

  const { data, isFetching, isLoading } =
    useGetAllConfigDataQuery("Blog-Sub-Category");
  const [deleteConfigData, deleteConfigDataInfo] =
    useDeleteConfigDataMutation();

  const [update, updateInfo] = useUpdateConfigDataMutation();

  useEffect(() => {
    deleteConfigData({
      id: configDataId,
      body: {
        action: "DELETE",
        data: {
          _id: getId,
        },
      },
    });
  }, [getId]);

  const createData = (subcategory_name, order_rank, actions) => {
    return { subcategory_name, order_rank, actions };
  };

  useEffect(() => {
    if (!isLoading && !isFetching) {
      setRows(
        data?.data[0]?.configurationValues?.map((module, index) => {
          return createData(
            module.value_name,
            module.order_rank,
            <div>
              <AuthWrapper
                type="ACTION"
                name="CONFIGURATION_BLOG_SUB_CATEGORY_DELETE"
              >
                <EditDelete type="delete" setGetid={setGetId} id={module._id} />
              </AuthWrapper>
              <AuthWrapper
                type="ACTION"
                name="CONFIGURATION_BLOG_SUB_CATEGORY_EDIT"
              >
                <EditDelete
                  type="edit"
                  setEditDialog={setEditDialog}
                  setData={setEditData}
                  data={module}
                />
              </AuthWrapper>
            </div>
          );
        }) || []
      );

      setConfigDataId(data?.data[0]?._id);
    }
  }, [isFetching, isLoading, data]);

  return (
    <>
      <BlogSubCategoryListing
        columns={getFilterdColumns(columns)}
        rows={rows}
        configDataId={configDataId}
      />
      {editDialog && (
        <EditBlogSubCategory
          editData={editData}
          onClose={() => setEditDialog(false)}
          configDataId={configDataId}
          update={update}
          loading={isFetching || isLoading}
        />
      )}

      {deleteConfigDataInfo?.data && <Toster info={deleteConfigDataInfo} />}
      {updateInfo?.data && <Toster info={updateInfo} />}
    </>
  );
};

export default BlogSubCategoryListingWrapper;
